export default __webpack_public_path__ + "scene01c5c3ae.jpg";